import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { Tooltip, IconButton } from "@material-ui/core";
import { useHistory } from 'react-router-dom';
import EstatusCuenta from './EstatusCuenta';
import EstatusDocumentoLabel from './EstatusDocumento';
import { formatDinero } from "../../../utils/formatDinero"
const columns = [
    { id: "referencia", minWidth: 150, align: "center", label: 'Referencia' },
    { id: "no.Pax", minWidth: 50, align: "center", label: 'No. Pax' },
    { id: "monto", minWidth: 50, align: "center", label: 'Monto' },
    { id: "doc", minWidth: 50, align: "center", label: 'Documentos' },
    { id: "reserva", minWidth: 50, align: "center", label: 'Reserva' },
    { id: "aereo", minWidth: 50, align: "center", label: 'Aereo' },
    { id: "liquidacion", minWidth: 50, align: "center", label: 'Liquidacion' },
    { id: "seguros", minWidth: 50, align: "center", label: 'Seguros' },
    { id: "equipaje", minWidth: 50, align: "center", label: 'Equipaje' },
    { id: "action", minWidth: 50, align: "center", label: "" }
];

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

export default function TGrupoDetalle({ rows = [] }) {
    const history = useHistory()
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    }
    const onDetalle = (row) => {
        history.push(`/ClienteDetalle/${row?.meta?.Referencia}`)
    }
    return (
        <Paper className={classes.root}>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                    <TableCell align='center'>
                                        {`${row?.meta?.Referencia}`}
                                    </TableCell>
                                    <TableCell align="center">
                                        {row?.meta?.Paquete?.Numero_Personas}
                                    </TableCell>
                                    <TableCell align="center">
                                        {formatDinero(row?.meta?.Paquete?.Monto_Paquete)}
                                    </TableCell>
                                    <TableCell align='center'>
                                        {
                                            (row?.meta?.Paquete?.Internacional) &&
                                            <EstatusDocumentoLabel estatus={row?.EstatusDoc} />
                                        }
                                        {
                                            (!row?.meta?.Paquete?.Internacional) &&
                                            <div>N/A</div>
                                        }
                                    </TableCell>
                                    <TableCell align="center">
                                        <EstatusCuenta estatus={row?.EstatusReserva} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <EstatusCuenta estatus={row?.EstatusAereo} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <EstatusCuenta estatus={row?.EstatusLiquidacion} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <EstatusCuenta estatus={row?.EstatusSeguro} />
                                    </TableCell>
                                    <TableCell align="center">
                                        <EstatusCuenta estatus={row?.EstatusEquipaje} />
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title="Ver detalle">
                                            <IconButton
                                                aria-label="Ver detalle"
                                                onClick={() => { onDetalle(row) }}
                                            >
                                                <AssignmentIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}